import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

/** Mapeo sección UI → DriverAccountStatus Nest */
export const STATUS_BY_TIPO = {
  solicitudes: 'solicitud',
  activos: 'activo',
  inactivos: 'inactivo',
  'en-viaje': 'enviaje',
  tripaceptado: 'tripaceptado',
  calificando: 'calificando',
};

/**
 * Adapta el modelo Nest a la forma que usan las pantallas/modal.
 */
export function mapDriverForUi(driver) {
  if (!driver) return null;
  const firstName = driver.firstName || '';
  const lastName = driver.lastName || '';
  return {
    ...driver,
    uid: driver.id,
    id: driver.id,
    name: `${firstName} ${lastName}`.trim() || driver.email || '—',
    status: driver.accountStatus,
    driverPhoto: driver.profilePhotoUrl,
    vehiclePhoto: driver.vehiclePhotoUrl,
    frontIDPhoto: driver.frontIdPhotoUrl,
    backIDPhoto: driver.backIdPhotoUrl,
    frontCredentialPhoto: driver.frontCredentialPhotoUrl,
    backCredentialPhoto: driver.backCredentialPhotoUrl,
    vehiclePermission: driver.vehiclePermissionUrl,
    criminalRecord: driver.criminalRecordUrl,
    sii: driver.siiUrl,
    paymentAccount: driver.paymentAccount,
  };
}

/**
 * @param {keyof typeof STATUS_BY_TIPO | string} tipo
 */
export async function fetchConductores(tipo) {
  const status = STATUS_BY_TIPO[tipo] || tipo;
  const qs = status ? `?status=${encodeURIComponent(status)}` : '';
  const response = await apiFetch(`${API_BASE}/admin/drivers${qs}`, {
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudieron cargar los conductores'));
  }
  const list = Array.isArray(payload) ? payload : [];
  return list.map(mapDriverForUi);
}

export async function fetchConductorDetail(id) {
  const response = await apiFetch(
    `${API_BASE}/admin/drivers/${encodeURIComponent(id)}`,
    { headers: authHeaders() },
  );
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo cargar el conductor'));
  }
  return mapDriverForUi(payload);
}

export async function approveConductor(id) {
  const response = await apiFetch(
    `${API_BASE}/admin/drivers/${encodeURIComponent(id)}/approve`,
    { method: 'PATCH', headers: authHeaders() },
  );
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo aprobar el conductor'));
  }
  return payload;
}

export async function rejectConductor(id) {
  const response = await apiFetch(
    `${API_BASE}/admin/drivers/${encodeURIComponent(id)}/reject`,
    { method: 'PATCH', headers: authHeaders() },
  );
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo rechazar el conductor'));
  }
  return payload;
}

export async function deactivateConductor(id) {
  const response = await apiFetch(
    `${API_BASE}/admin/drivers/${encodeURIComponent(id)}/deactivate`,
    { method: 'PATCH', headers: authHeaders() },
  );
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo desactivar el conductor'));
  }
  return payload;
}
